// src/components/Home/ActionCardsSection.tsx
import React, {useRef} from 'react';
import Button from '../Button';
import {useIsMobile} from "../../../../hooks/useIsMobile";
import {motion, useInView} from "framer-motion";
import {useNavigate} from "react-router-dom";

interface CardProps {
    icon: React.ReactNode;
    title: string;
    description: string;
    index: number;
}


const ActionCard: React.FC<CardProps> = ({ icon, title, description, index  }) => {

const isMobile = useIsMobile();

    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });
    const navigate = useNavigate();

return (

    <motion.div
        ref={ref}
        initial={{opacity: 0}}
        animate={isInView ? {opacity: 1, y: 0} : {}}
        transition={{duration: 0.5, delay: 0.4 + index * 0.2, ease: 'easeOut',}}
        className="pt-4 px-3.5 pb-3 w-full gap-3 bg-white rounded-[16px] border-[1px] border-[#19CF7A1A] shadow-[0 4px 6px 0 rgba(245, 245, 245, 0.50), 0 10px 15px 0 rgba(245, 245, 245, 0.50)] min-h-[162px] transition-transform duration-300 hover:shadow-xl hover:-translate-y-1 flex flex-row  "
    >

        <div
            className="flex  justify-center items-center w-[64px] h-[64px] md:w-[48px] md:h-[48px] py-4 md:p-2 px-4 rounded-[12px] border-0 border-[#E5E7EB] bg-[#19CF7A1A]">
            <div>{icon}</div>
        </div>


        <div className={"flex flex-col gap-3"}>
            <div className={"flex flex-col"}>
                <h3 className="text-2xl md:text-base font-boldtext-[#111827]">{title}</h3>
                <span className="text-[#6C7B7F] text-base leading-[26px] md:leading-[23px] md:text-sm font-medium md:font-normal flex-grow">{description}</span>
            </div>


            <button

                onClick={() => {
                    if (index === 1) {
                        navigate('/author');
                        setTimeout(() => window.scrollTo(0, 0), 100);

                    } else if (index === 2) {
                        navigate('/book');
                        setTimeout(() => window.scrollTo(0, 0), 100);

                    } else if (index === 3) {
                        navigate('/postcard');
                        setTimeout(() => window.scrollTo(0, 0), 100);

                    }

                }}
                className={`flex flex-row gap-2 justify-center items-center text-base font-semibold md:text-sm self-start hover:underline transition-colors duration-200 ${
                    index === 2 ? 'text-[#6C7B7F] hover:text-[#6C7B7F]' : 'text-main hover:text-green-600'
                }`}
            >
                자세히 보기
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none"
                     className={"md:w-3.5 md:h-3.5"}>
                    <g clip-path="url(#clip0_4962_10848)">
                        <path
                            d="M14.5656 8.70615C14.9563 8.31553 14.9563 7.68115 14.5656 7.29053L9.56563 2.29053C9.175 1.8999 8.54063 1.8999 8.15 2.29053C7.75938 2.68115 7.75938 3.31553 8.15 3.70615L11.4469 6.9999H1.85938C1.30625 6.9999 0.859375 7.44678 0.859375 7.9999C0.859375 8.55303 1.30625 8.9999 1.85938 8.9999H11.4438L8.15312 12.2937C7.7625 12.6843 7.7625 13.3187 8.15312 13.7093C8.54375 14.0999 9.17813 14.0999 9.56875 13.7093L14.5688 8.70928L14.5656 8.70615Z"
                            fill={index === 2 ? '#6C7B7F' : '#16B96A'}/>
                    </g>
                    <defs>
                        <clipPath id="clip0_4962_10848">
                            <path d="M0.859375 0H14.8594V16H0.859375V0Z" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
            </button>

        </div>


    </motion.div>
);

}

const ActionCardsSection: React.FC = () => {
    const ref = useRef(null);
    const isInView = useInView(ref, {once: true, margin: "-100px"});

    const isMobile = useIsMobile();


    return (


        <div className={"flex flex-col gap-[30px]"}>


            <motion.div
                ref={ref}
                className="flex flex-col gap-3 text-center "
                initial={{opacity: 0, y: 20}}
                animate={isInView ? {opacity: 1, y: 0} : {}}
                transition={{duration: 0.6, delay: 0}}
            >
                <h2 className="text-[36px] md:text-[20px] font-extrabold  text-[#111827]">
                    무엇을 할 수 있나요?
                </h2>
                <motion.span
                    ref={ref}
                    className="text-[24px] md:text-sm text-[#6C7B7F] md:leading-[22px] font-normal text-center"
                    initial={{opacity: 0, y: 20}}
                    animate={isInView ? {opacity: 1, y: 0} : {}}
                    transition={{duration: 0.6, delay: 0.2}}
                >
                    작가와 독자를 연결하는 다양한 기능들을 <br className="hidden md:block"/> 경험해 보세요.
                </motion.span>
            </motion.div>


            <section className="py-[32px] px-4 md:px-8 flex flex-col gap-[64px] "
                     style={{
                         background: 'linear-gradient(90deg, #F5F8F6 0.07%, #F4FBF7 99.93%)'
                     }}
            >


                <div className="max-w-6xl mx-auto grid grid-cols-3 gap-6 md:grid-cols-1 ">
                    <ActionCard
                        icon={
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="18" viewBox="0 0 23 18"
                                 fill="none">
                                <g clip-path="url(#clip0_5270_7391)">
                                    <path
                                        d="M7.875 9C9.06847 9 10.2131 8.52589 11.057 7.68198C11.9009 6.83807 12.375 5.69347 12.375 4.5C12.375 3.30653 11.9009 2.16193 11.057 1.31802C10.2131 0.474106 9.06847 0 7.875 0C6.68153 0 5.53693 0.474106 4.69302 1.31802C3.84911 2.16193 3.375 3.30653 3.375 4.5C3.375 5.69347 3.84911 6.83807 4.69302 7.68198C5.53693 8.52589 6.68153 9 7.875 9ZM6.26836 10.6875C2.80547 10.6875 0 13.493 0 16.9559C0 17.5324 0.467578 18 1.04414 18H11.3484C11.2395 17.6906 11.2184 17.3531 11.2992 17.0227L11.8266 14.9098C11.925 14.5125 12.1289 14.1539 12.4172 13.8656L13.834 12.4488C12.7055 11.359 11.1727 10.6875 9.47813 10.6875H6.26836ZM21.5789 8.28633C21.0305 7.73789 20.141 7.73789 19.5891 8.28633L18.5555 9.31992L21.0516 11.816L22.0852 10.7824C22.6336 10.234 22.6336 9.34453 22.0852 8.79258L21.5789 8.28633ZM13.2152 14.6602C13.0711 14.8043 12.9691 14.9836 12.9199 15.184L12.3926 17.2969C12.3434 17.4902 12.3996 17.6906 12.5402 17.8313C12.6809 17.9719 12.8812 18.0281 13.0746 17.9789L15.1875 17.4516C15.3844 17.4023 15.5672 17.3004 15.7113 17.1562L20.2535 12.6105L17.7574 10.1145L13.2152 14.6602Z"
                                        fill="#19CF7A" fill-opacity="0.2"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_5270_7391">
                                        <path d="M0 0H22.5V18H0V0Z" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        }
                        title="작가 소개"
                        description="독자에게 전하고 싶은 솔직 담백한 자기 소개와 출간작, 자주 쓰는 작품 유형 등을 소개해 보세요."
                        index={1}
                    />
                    <ActionCard
                        icon={<svg xmlns="http://www.w3.org/2000/svg" width="21" height="24" viewBox="0 0 21 24"
                                   fill="none">
                            <path
                                d="M6.42857 2C4.53571 2 3 3.5957 3 5.5625V17.4375C3 19.4043 4.53571 21 6.42857 21H16.7143H17.8571C18.4893 21 19 20.4693 19 19.8125C19 19.1557 18.4893 18.625 17.8571 18.625V16.25C18.4893 16.25 19 15.7193 19 15.0625V3.1875C19 2.53066 18.4893 2 17.8571 2H16.7143H6.42857ZM6.42857 16.25H15.5714V18.625H6.42857C5.79643 18.625 5.28571 18.0943 5.28571 17.4375C5.28571 16.7807 5.79643 16.25 6.42857 16.25ZM7.57143 7.34375C7.57143 7.01719 7.82857 6.75 8.14286 6.75H15C15.3143 6.75 15.5714 7.01719 15.5714 7.34375C15.5714 7.67031 15.3143 7.9375 15 7.9375H8.14286C7.82857 7.9375 7.57143 7.67031 7.57143 7.34375ZM8.14286 9.125H15C15.3143 9.125 15.5714 9.39219 15.5714 9.71875C15.5714 10.0453 15.3143 10.3125 15 10.3125H8.14286C7.82857 10.3125 7.57143 10.0453 7.57143 9.71875C7.57143 9.39219 7.82857 9.125 8.14286 9.125Z"
                                fill="#6C7B7F"/>
                        </svg>}
                        title="출간작 알리기"
                        description="작품의 핵심 키워드와 출간 계기를 써보세요. 독자들에게 작품을 보는 새로운 관점을 제공할 수 있어요!"
                        index={2}

                    />
                    <ActionCard
                        icon={
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                 fill="none">
                                <path
                                    d="M2 5.57143C2 4.15313 3.12109 3 4.5 3H19.5C20.8789 3 22 4.15313 22 5.57143V18.4286C22 19.8469 20.8789 21 19.5 21H4.5C3.12109 21 2 19.8469 2 18.4286V5.57143ZM14.6484 9.85045C14.4727 9.58527 14.1836 9.42857 13.875 9.42857C13.5664 9.42857 13.2734 9.58527 13.1016 9.85045L9.70312 14.9772L8.66797 13.6473C8.48828 13.4183 8.21875 13.2857 7.9375 13.2857C7.65625 13.2857 7.38281 13.4183 7.20703 13.6473L4.70703 16.8616C4.48047 17.1509 4.4375 17.5487 4.59375 17.8821C4.75 18.2156 5.07813 18.4286 5.4375 18.4286H9.1875H10.4375H18.5625C18.9102 18.4286 19.2305 18.2317 19.3906 17.9143C19.5508 17.5969 19.5312 17.2152 19.3359 16.9219L14.6484 9.85045ZM6.375 9.42857C6.87228 9.42857 7.3492 9.22538 7.70083 8.86371C8.05246 8.50203 8.25 8.01149 8.25 7.5C8.25 6.98851 8.05246 6.49797 7.70083 6.13629C7.3492 5.77462 6.87228 5.57143 6.375 5.57143C5.87772 5.57143 5.40081 5.77462 5.04918 6.13629C4.69754 6.49797 4.5 6.98851 4.5 7.5C4.5 8.01149 4.69754 8.50203 5.04918 8.86371C5.40081 9.22538 5.87772 9.42857 6.375 9.42857Z"
                                    fill="#16B96A"/>
                            </svg>
                        }
                        title="책과 관련된 엽서 홍보"
                        description="책과 함께 소개하고 싶은 엽서를 보여주세요. 책을 다 읽고도 남는 여운, 엽서로 독자와 이어가 보세요!"
                        index={3}
                    />
                </div>
            </section>


        </div>
    );
};

export default ActionCardsSection;
